import { render, staticRenderFns } from "./FormsListener.vue?vue&type=template&id=56c0af08&"
import script from "./FormsListener.vue?vue&type=script&lang=js&"
export * from "./FormsListener.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports